<template>
  <b-row class="match-height">
    <!-- progress -->
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 420px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <span style="font-size:20px; color: #fff; margin-left: 15px;">5 Top ประเภทยานพาหนะการจราจร</span>
        </div>

        <!-- <div>
          <app-echart-bar
            :option-data="optionBar1"
            style="width:auto; height:355px;"
          />
        </div> -->
      </b-card>
    </b-col>

    <!-- progress8 -->
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <span style="color:#ffffff;font-size:24px;">5 Top จุดติดตั้งป้ายจราจรสูงสุด</span>
        </div>
        <b-row
          v-for="(item, index) in progress.slice(0,5)"
          :key="index"
          style="margin-top:10px"
          class="mt-2"
        >
          <b-col
            lg="10"
          >
            <label style="color: #ffffff; font-size: 18px;">{{ index+1 +'. ' }} {{ item.deptname }}</label>
            <b-progress
              style="width: 100%;"
              :value="item.Location_Traffic"
              :max="progress[0].Location_Traffic"
              precision="2"
              class="progress8"
            />
          </b-col>
          <b-col
            lg="2"
            style="text-align: center;"
          >
            <br>
            <span style="color:#ffffff; ">{{ item.Location_Traffic }} จุด</span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BProgress,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BProgress,
  },
  data() {
    return {

      progress: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    // this.get1Top5()
    this.get2Top5()
    this.interval = setInterval(() => {
      // this.get1Top5()
      this.get2Top5()
    }, 300000)
  },
  methods: {
    // get1Top5() {
    //   axios
    //     .post('/getTop5TotalTraffic', { department: this.userData.department })
    //     .then(response => {
    //       // eslint-disable-next-line prefer-destructuring
    //       this.progress = response.data
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    get2Top5() {
      axios
        .post('/getTop5TotalTraffic', { department: this.userData.department })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}
.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
